function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C7DEE2",
  d: "M18.878 84.82c-.821-.59-1.867.276-2.338 1.936l-5.1 18.03c-.47 1.66-.184 3.48.637 4.073.821.59 1.868-.276 2.338-1.935l5.102-18.03c.469-1.662.183-3.487-.639-4.074z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD33B",
  d: "M40.372 2.234C24.007-2.349 7.841 5.25 2.14 27.474c-5.7 22.228 2.085 47.318 18.45 51.897 16.363 4.583 35.113-13.078 40.81-35.306 5.704-22.224-4.66-37.252-21.028-41.831z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEC745",
  d: "M21.83 76.27c-5.924-1.69-12.418 5.304-13.043 7.786-.624 2.482.965 4.112 2.547 4.562 1.581.45 12.208 3.484 13.789 3.936 1.58.449 3.722-.114 4.349-2.596.623-2.482-1.717-11.994-7.641-13.688z"
}));

function SvgYellowBalloon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 110,
    ref: svgRef
  }, props), _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBalloon);
export default __webpack_public_path__ + "static/media/yellow-balloon.c4a3f7e1.svg";
export { ForwardRef as ReactComponent };